var $18cf3acc4056ec0e$exports = {};
$18cf3acc4056ec0e$exports = {
    "Empty": `\u{386}\u{3B4}\u{3B5}\u{3B9}\u{3BF}`
};


export {$18cf3acc4056ec0e$exports as default};
//# sourceMappingURL=el-GR.mjs.map
